export default "__VITE_ASSET__CY61P0Z7__";